// extracted by mini-css-extract-plugin
export default {"card":"gZ-z","carouselContainer":"hZ-z","carouselContent":"iZ-z"};